import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { IListPublicationsRequest } from "../../../model/base/request/list-publications-request";
import { ACTION_TYPES, usePublicationsDispatch } from "./publications-context";

export const usePublicationsController = () => {
    const dispatch = usePublicationsDispatch();

    async function loadData(params: IListPublicationsRequest) {
        try {
            // Limpa as publicações antes de carregar novos dados
            dispatch({
                type: ACTION_TYPES.clearPublications,
            });
            const publications = await PortalAppService.requestPublications(params);
            dispatch({
                type: ACTION_TYPES.setPublications,
                payload: publications,
            });
        } catch (error) {
            console.error('Error loading publications:', error);
        }
    }

    async function loadCategories() {
        try {
            const categories = await BaseAppService.getListCategoryPublication();
            dispatch({
                type: ACTION_TYPES.setCategories,
                payload: categories,
            });
        } catch (error) {
            console.error('Error loading categories:', error);
        }
    }

    async function loadSubcategories(categoryId: number) {
        try {
            const subcategories = await BaseAppService.getListSubCategoryPublication({ categoryId });
            dispatch({
                type: ACTION_TYPES.setSubcategories,
                payload: subcategories,
            });
        } catch (error) {
            console.error('Error loading subcategories:', error);
        }
    }

    async function loadPublishingVehicles() {
        try {
            const publishingVehicles = await BaseAppService.getListPublishingVehicle();
            dispatch({
                type: ACTION_TYPES.setPublishingVehicles,
                payload: publishingVehicles,
            });
        } catch (error) {
            console.error('Error loading publishing vehicles:', error);
        }
    }

    return {
        loadData,
        loadCategories,
        loadSubcategories,
        loadPublishingVehicles
    };
};
